<template>
  <div style="height: 100%; width: 100%; display: flex; flex-direction: row; justify-content: flex-start;">
    <div style="display: flex; flex-direction: row; width: 100%;">
      <div style=" display: flex; flex-direction: row;">
        {{label}}<div style="display: inline-block;">:</div>
      </div>
      <input
        type="text"
        style="border: 1px solid rgba(34,36,38,.15); border-radius: 0.35rem;"
        :style="`width: ${value.length + 2}ch;`"
        @blur="editing = false"
        v-if="editing"
        v-model="value"
        :identifier="`${identifier}-text`"
        @change="handleInput"
        />
      <div
        v-else-if="!editing"
        @click="editing = true"
        class="editable-input"
        style="padding-left: .5rem; cursor: pointer;"
        >
        {{value}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormTextInput',
  props: {
    identifier: {
      required: true,
    },
    initialValue: {
      required: true,
    },
    label: String,
  },
  data () {
    return {
      editing: false,
      value: undefined,
    }
  },
  methods: {
    handleInput (event) {
      this.value = event.target.value
      this.$emit('change', this.value)
    },
  },
  computed: {
  },
  mounted () {
    this.value = this.initialValue
  },
}
</script>

<style>
</style>
